import { showDialog } from 'vant';
import md5 from 'js-md5';
import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import { SOURCE_TYPE } from '@/config';
import { mapGetters } from 'vuex';
import cptCmn from '@/mixin/cpt-cmn';
import verificationCodeImg from '@/mixin/verification-code-img';
import { rqtPostAppointmentSave, rqtGetAppointment } from '@/services/wms/appointment';
import ValidateCodePageCpt from '@/components/validate/ValidateCodePageCpt';
import StandCountdownCpt from "@/components/countdown";
const CustomerQueryCpt = () => import('@/components/customer/CustomerQueryCpt');
export default {
  mixins: [cptCmn, verificationCodeImg],
  components: {
    PageNavBackLayoutCpt,
    CustomerQueryCpt,
    ValidateCodePageCpt,
    StandCountdownCpt
  },
  data() {
    return {
      form: {
        agentId: '',
        customerId: '',
        customerAccountId: '',
        customerAddressId: '',
        customerContactId: '',
        productId: '',
        openDate: '',
        amount: '',
        validateCode: '',
        sourceType: SOURCE_TYPE
      },
      btnLoading: false,
      agent: {},
      production: {},
      customer: {},
      codeResItems: [{
        title: '风险等级',
        dataIndex: 'riskGrade',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'riskGrade'
      }],
      queryItem: {},
      startTime: '',
      canSubmit: false
    };
  },
  computed: {
    ...mapGetters('account', ['user'])
  },
  created() {
    let item = this.$route.query && this.$route.query.item;
    if (item) {
      this.initResCodeType(this.codeResItems);
      item = JSON.parse(item);
      this.queryItem = item;
      try {
        this.agent.agentName = this.user.name.split('-')[1];
      } catch (error) {
        console.error(error);
      }
      this.production = {
        ...this.queryItem
      };
      let params = {
        agentId: this.user.agentId,
        productId: this.production.productId,
        raiseStartDate: this.production.raiseStartDate
      };
      rqtGetAppointment(params).then(res => {
        let resData = res.data.data;
        this.startTime = resData.times;
        if (resData.times > 0) {
          this.canSubmit = false;
        } else {
          this.canSubmit = true;
        }
      }).catch(() => {
        this.canSubmit = false;
      });
    }
    //this.onFreshCodeClickForAppointment({productId: this.production.productId, openDate: this.production.openDate})
  },

  methods: {
    onSubmitData(params) {
      this.btnLoading = true;
      this.form.agentId = this.user.agentId;
      this.form.productId = this.production.productId;
      this.form.customerAccountId = this.customer.customerAccountId;
      this.form.customerAddressId = this.customer.customerAddressId;
      this.form.customerContactId = this.customer.customerContactId;
      this.form.customerId = this.customer.id;
      this.form.openDate = this.queryItem.openDate;
      // this.form.uuid_key = this.codeUuidKey
      this.form.uuid_key = params.uuid_key;
      this.form.validateCode = params.validateCode;
      let SIGN_KEY = params.uuid_key;
      let md5_key = undefined;
      if (!this.form.openDate) {
        md5_key = md5(SIGN_KEY + this.form.productId + 'null' + this.form.amount + this.form.customerId);
      } else {
        md5_key = md5(SIGN_KEY + this.form.productId + this.form.openDate + this.form.amount + this.form.customerId);
      }
      this.form.sign = md5_key;
      rqtPostAppointmentSave(this.form).then(res => {
        const resData = res.data.data;
        showDialog({
          message: resData
        }).then(() => {
          this.$router.go(-1);
        }).catch(() => {});
        this.btnLoading = false;
      }).catch(() => {
        this.btnLoading = false;
      });
    },
    onSubmit() {
      //首选弹出验证码输入框
      let params = {
        productId: this.production.productId,
        openDate: this.production.openDate
      };
      // console.log('----params--',params)
      this.$refs['ValidateCodePageCpt'].showView(params);
    },
    onConfirmCode(params) {
      // console.log('---onConfirmCode-params--',params)
      this.onSubmitData(params);
    },
    onSelectCustomerClick() {
      this.$refs['CustomerQueryCpt'].showView();
    },
    onCustomerSelected(value) {
      this.customer = value;
    },
    autoReFresh() {
      // this.$refs.ListViewCpt.initListData()
      this.canSubmit = true;
    }
  }
};